var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgELetter = function SvgELetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 105 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e-letter_svg__a)",
    d: "M34.763 30.305v22.044h54.852v13.61c0 9.916-4.939 14.88-14.805 14.88H34.763v24.856h55.212c9.927 0 14.895 4.963 14.895 14.88v15.42H.706V.005H104.87v15.42c0 9.917-4.968 14.88-14.895 14.88z",
    className: "e-letter_svg__Vector"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e-letter_svg__a",
    x1: -420.197,
    x2: 549.568,
    y1: 4.458,
    y2: 135.013,
    className: "e-letter_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })))));
};
export default SvgELetter;